import Masthead from './connected';

export default Masthead;
